const IconCloseCircle = (): JSX.Element => {
  return (
    <>
      <path
        d="M10 0C11.3833 3.01614e-08 12.6837 0.262109 13.9004 0.787109C15.117 1.3121 16.1752 2.02485 17.0752 2.9248C17.9751 3.82476 18.6879 4.88302 19.2129 6.09961C19.7379 7.31628 20 8.61667 20 10C20 11.3666 19.7379 12.6584 19.2129 13.875C18.6879 15.0916 17.9751 16.1542 17.0752 17.0625C16.1752 17.9708 15.117 18.6879 13.9004 19.2129C12.6837 19.7379 11.3833 20 10 20C8.63339 20 7.34163 19.7379 6.125 19.2129C4.90833 18.6879 3.84583 17.9708 2.9375 17.0625C2.02917 16.1542 1.31211 15.0917 0.787109 13.875C0.26215 12.6584 3.05283e-08 11.3666 0 10C0 8.61667 0.262109 7.31628 0.787109 6.09961C1.3121 4.88302 2.02921 3.82476 2.9375 2.9248C3.84581 2.02485 4.90838 1.31209 6.125 0.787109C7.34163 0.26215 8.63339 0 10 0ZM10 8.9502L6.25 5.2002L5.2002 6.25L8.9502 10L5.2002 13.75L6.25 14.7998L10 11.0498L13.75 14.7998L14.7998 13.75L11.0498 10L14.7998 6.25L13.75 5.2002L10 8.9502Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconCloseCircle;
